/**
 * Parses a page range string like "1-3,5,10-" into a Set of page numbers.
 * Supports single pages, ranges (1-3), and open-ended ranges (10-) which go to pageMax.
 */
export function pageRangeToPageNumbers(range: string, pageMax: number): Set<number> {
  const pages = new Set<number>();
  const rangeClean = range.replace(/[^0-9,-]+/g, '');

  for (const item of rangeClean.split(',')) {
    if (item === '') {
      continue;
    }

    if (/^\d+$/.test(item)) {
      pages.add(parseInt(item));
      continue;
    }

    const results = /^(\d+)-(\d+)?$/.exec(item);
    if (!results) {
      console.warn(`pageRangeToPageNumbers: Could not parse range part: ${JSON.stringify(item)}`);
      continue;
    }

    let start = parseInt(results[1]);
    let end = typeof results[2] === 'string' ? parseInt(results[2]) : pageMax;
    // Ensure typoed ranges do not cause us to emit huge numbers of pages:
    start = Math.max(0, Math.min(start, pageMax));
    end = Math.max(0, Math.min(end, pageMax));

    for (let i = start; i <= end; i++) {
      pages.add(i);
    }
  }

  return pages;
}
